import React, { useEffect, useState, useRef } from 'react';
import { api } from '@/api/client';
import TransportDiagnostic from './TransportDiagnostic';

export default function VoiceDiagnostic({ streamId }) {
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const attempted = useRef(false);
  const path = `/livestreams/${encodeURIComponent(streamId)}/voice-diagnostic`;
  useEffect(() => {
    let alive = true;
    api(path, { auth: true }).then(s => { if (alive) setStatus(s); }).catch(() => {});
    return () => { alive = false; };
  }, [path]);
  async function run() {
    if (attempted.current || busy || status?.status !== 'ready') return;
    attempted.current = true; setBusy(true); setError('');
    try {
      const result = await api(path, { auth: true, method: 'POST', timeoutMs: 40000 });
      setStatus({ status: 'finished', result });
    } catch (_) {
      setError('The result is not confirmed. Check status; this test will not retry.');
    } finally { setBusy(false); }
  }
  async function refresh() {
    try { setStatus(await api(path, { auth: true })); } catch (_) { setError('Status unavailable. No retry was sent.'); }
  }
  if (!status) return null;
  return <><TransportDiagnostic key={`${streamId}-conversation`} streamId={streamId} conversation /><TransportDiagnostic key={streamId} streamId={streamId} /><section className="tt-panel p-4 rounded-xl space-y-3" aria-label="Private synthetic voice diagnostic">
    <h2 className="text-xl">Private synthetic voice check</h2>
    <p>One approved test: up to 30 seconds, one AI attempt and one response of at most 300 characters. Uses existing paid providers. No microphone, camera or recording. This checks the speech pipeline, not two-person LiveKit transport.</p>
    <p role="status">{busy ? 'Running the single test…' : status.status}</p>
    <button className="border rounded p-2" disabled={busy || attempted.current || status.status !== 'ready'} onClick={run}>Run the single approved synthetic test</button>
    <button className="border rounded p-2" disabled={busy} onClick={refresh}>Check diagnostic status</button>
    {status.result && <pre className="whitespace-pre-wrap text-xs">{JSON.stringify(status.result, null, 2)}</pre>}
    {error && <p role="alert">{error}</p>}
  </section></>;
}
